import { useQuery } from '@tanstack/react-query';
import createPrivateAdminPanelInstance from '../api/PrivateAdminPanelInstance';
import { API_ROUTES } from '../api/ApiRoutes';

const fetchSportsOrdering = async () => {
  const token = JSON.parse(localStorage.getItem('token'));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const response = await PrivateAdminPanelInstance.post(
    API_ROUTES.GET_SPORTS_ORDERING,
    { entity_type: 'ALL_SPORTS' }
  );

  return response.data?.data?.sports ?? [];
};

export const useGetSportsOrdering = () => {
  return useQuery({
    queryKey: ['GET_SPORTS_ORDERING'],
    queryFn: fetchSportsOrdering,
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};

